import React, { useState } from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';

import { useSelector } from 'react-redux';

import { drawSeriesCallsHourlyBar } from '../../selectors/call';
import { selectUserByRole } from '../../selectors/user';
import ReactApexChart from 'react-apexcharts';

import roles from '../../config/roles';
import { useTranslation } from 'react-i18next';
import { orderByKey, isMobileViewport } from '../../helpers/sharedFunction';

const CallsHourlyBar = (props) => {
  const user = useSelector((state) => state.Auth.admin);
  const initialUserId = user.role === roles['OPERATOR'] ? user.id : null;
  const [userId, setUserId] = useState(initialUserId);

  const users = useSelector(
    selectUserByRole([roles.OPERATOR, roles.TEAM_LEADER], true),
  );

  const { t } = useTranslation();

  const dataBar = useSelector(drawSeriesCallsHourlyBar(userId));

  const handleOperator = (selectedUserId) => {
    setUserId(selectedUserId === 'all' ? null : selectedUserId);
  };

  const hourlyBar = {
    series: [
      {
        data: dataBar.series,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 270,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          barHeight: '100%',
          distributed: true,
          horizontal: true,
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => val,
        style: {
          fontSize: '12px',
          colors: ['#fff'],
        },
      },
      fill: {
        opacity: 1,
      },
      stroke: {
        width: 1,
        colors: ['#fff'],
      },
      xaxis: {
        categories: dataBar.labels,
        labels: {
          formatter: (val) => val,
        },
      },
      yaxis: {
        // Horizontal bars take the value axis ticks from yaxis; a phone-wide
        // axis has room for only a few labels
        tickAmount: isMobileViewport() ? 4 : undefined,
        labels: {
          formatter: (val) => `${val}h`,
        },
      },
      tooltip: {
        enabled: false,
      },
      legend: {
        show: false,
      },
    },
  };

  return (
    <Card>
      <CardBody>
        <div className="clearfix">
          {!initialUserId && (
            <div className="float-right">
              <div className="input-group input-group-sm">
                <select
                  className="custom-select custom-select-sm"
                  defaultValue="all"
                  onChange={(e) => handleOperator(e.target.value)}
                >
                  <option key="all" value="all">
                    {t('All')}
                  </option>
                  {Array.isArray(users) &&
                    orderByKey(users, 'lastName').map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.displayName}
                      </option>
                    ))}
                </select>
                <div className="input-group-append">
                  <label className="input-group-text">{t('Operator')}</label>
                </div>
              </div>
            </div>
          )}
          <CardTitle className="mb-1">
            {t('Closed Calls')} - {t('Time slot')}
          </CardTitle>
        </div>
        <div id="calls-hourly-chart" className="apex-charts" dir="ltr">
          <ReactApexChart
            series={hourlyBar.series}
            options={hourlyBar.options}
            type="bar"
            height={270}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default CallsHourlyBar;
